import React from 'react'

const CustomNoData = ({
  title = 'No data available',
  description = 'No matches found for the selected filters.',
  py = 20,
  className = '',
}) => {
  const verticalPadding = Number.isFinite(Number(py)) ? Number(py) * 0.25 : 5

  return (
    <div
      role="status"
      className={`col-span-full flex flex-col items-center justify-center gap-2 rounded-3xl border border-dashed border-customMuted bg-white px-4 text-center text-customMuted dark:border-custom_dark_secondary dark:bg-custom_dark_primary2 ${className}`}
      style={{ paddingTop: `${verticalPadding}rem`, paddingBottom: `${verticalPadding}rem` }}
    >
      <p className="text-sm font-semibold uppercase tracking-wide">{title}</p>
      <p className="max-w-xs text-xs text-customSecondaryText dark:text-customMuted">{description}</p>
    </div>
  )
}

export default CustomNoData;
